import React, { Component } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,Paper,CircularProgress,Alert,Button
} from '@mui/material';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';

class LoginStaffs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staffList: [],
      loading: true,
      error: '',
      role: '',
      roleName: ''
    };
  }

  componentDidMount() {
	   document.title = "Prep for Sale- Staff Management";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
  const role = parseInt(localStorage.getItem('DCrole'), 10);
  const assignedStaff = JSON.parse(localStorage.getItem('assignedStaff')) || [];

  if (!role) {
    this.setState({ error: 'No role found. Please log in again.', loading: false });
    return;
  }

  let roleName = '';
  if (role === 2) roleName = 'Service Staff';
  else if (role === 3) roleName = 'Inspection Staff';
  else roleName = 'Unknown';

  this.setState({ role, roleName, staffList: assignedStaff, loading: false });
}

 handleStatusChange = (sa_id, status) => {
  if (!sa_id) {
    this.setState({ error: 'Invalid staff assignment ID' });
    return;
  }

 axios.put(`${Serverurl}staffassign/statusupdate/${sa_id}`, { sa_status: status })
  .then(() => {
    this.setState((prevState) => ({
      staffList: prevState.staffList.map((staff) =>
        staff.sa_id === sa_id ? { ...staff, sa_status: status } : staff
      ),
      error: ''
    }));
  })
  .catch((err) => {
    console.error(err);
    this.setState({ error: 'Failed to update status' });
  });

    
};


  render() {
	  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
  

    if (this.state.loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
          <CircularProgress />
        </Box>
      );
    }

    return (
			 <div className="maincontentDiv">
      
        <Typography pb={2} pt={2} className="contentHeading" variant="h5" gutterBottom>
          {this.state.roleName} Dashboard
        </Typography>

        {this.state.error && (
          <Alert severity="error" sx={{ marginBottom: 2 }}>
            {this.state.error}
          </Alert>
        )}

        {this.state.staffList.length === 0 ? (
          <Typography variant="h5" align="center">Welcome</Typography>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead sx={{ backgroundColor: '#1976d2' }}>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
             <TableBody>
  {this.state.staffList.map((item) => (
    <TableRow key={item.sa_id}>
      <TableCell>{item.cu_name}</TableCell>
      <TableCell>{item.cu_emailid}</TableCell>
      <TableCell>{item.cu_phonenumber || '-'}</TableCell>
      <TableCell>
        {item.sa_status === 2 ? 'Assigned' :
         item.sa_status === 6 ? 'Accepted' :
         item.sa_status === 7 ? 'Rejected' : 'Unknown'}
      </TableCell>
      <TableCell>
        <Button
		size="small"
          variant="contained"
          color="success"
          onClick={() => this.handleStatusChange(item.sa_id, 6)}
        >
          Accept
        </Button>
        <Button
		size="small"
          variant="contained"
          color="error"
          sx={{ ml: 1 }}
          onClick={() => this.handleStatusChange(item.sa_id, 7)}
        >
          Reject
        </Button>
      </TableCell>
    </TableRow>
  ))}
</TableBody>

            </Table>
          </TableContainer>
        )}
      </div>
    );
  }
}

export default LoginStaffs;
